export const ACTIONS = {
  SET_TEACHER_CONTROL: 'SET_TEACHER_CONTROL',
  UNSET_TEACHER_CONTROL: 'UNSET_TEACHER_CONTROL',
  SET_WTC_SHEET_PATCH_ID: 'SET_WTC_SHEET_PATCH_ID',
  UNSET_WTC_SHEET_PATCH_ID: 'UNSET_WTC_SHEET_PATCH_ID',
};

export const setTeacherControl = payload => ({
  type: ACTIONS.SET_TEACHER_CONTROL,
  payload: {
    ...payload,
    timestamp: Number(new Date()),
    sheetPatchId: null,
  },
});

export const clearteacherControl = () => ({
  type: ACTIONS.UNSET_TEACHER_CONTROL,
  payload: {},
});

export const clearWTCSheetPatchId = () => ({
  type: ACTIONS.UNSET_WTC_SHEET_PATCH_ID,
});
